import React from 'react'
import { Avatar, Stack, Typography } from '@mui/material'
import { amber, green } from '@mui/material/colors'
import { useGlobalState } from 'state'
import { QuestionFrameContext } from 'components/questions'


type QuestionContentProps = {
  num: number
  content: string
}

export const Question = ({ num, content, children }: React.PropsWithChildren<QuestionContentProps>) => {
  const state = useGlobalState()
  const q = React.useContext(QuestionFrameContext)

  const backgroundColor = React.useMemo(() => {
    const answer = state.app.getAnswer(q, num)
    return answer !== null && answer.valid === true ? amber[50] : 'transparent'
  }, [state.app.answers])

  return (
    <Stack direction="column" alignItems={'start'} pb={5} width={'100%'}>

      <Stack direction="row" alignItems={'start'} pb={1}>
        <Avatar sx={{ bgcolor: green[400], width: 26, height: 26, fontSize: '1rem'}}>{num}</Avatar>
        <Typography variant='body1' align='left' sx={{fontSize: '1.1rem', ml: 2}} whiteSpace={'pre-wrap'}>{content}</Typography>
      </Stack>

      <Stack py={1} my={1} width={'100%'} sx={{
        borderTop: '1px dashed #bdbdbd',
        borderBottom: '1px dashed #bdbdbd',
        backgroundColor: backgroundColor
      }}>
        <Stack px={3}>
          {children}
        </Stack>
      </Stack>

    </Stack>
  )
}
